export default __webpack_public_path__ + "static/media/demonic-foliage.1d5e6cbc.jpg";